import React, { useState } from "react";
import { 
  Card, Button, Container, Row, Col, 
  ToggleButtonGroup, ToggleButton, Dropdown 
} from "react-bootstrap";
import NavBar from "./NavBar";
import Footer from "./Footer";
import { useTheme } from "./ThemeContext";
import { useNavigate } from "react-router-dom";
import useMediaQuery from 'react-responsive'

// ✅ Import JSON directly
import pricingData from "./PlanPricing.json";

const PricingPage = () => {
  const [planType, setPlanType] = useState(1); // 1 = Monthly, 2 = Quarterly
  const [selectedProduct, setSelectedProduct] = useState("LIMS"); // Default product
  const { theme } = useTheme();
  const navigate = useNavigate();
    const isSmallScreen = useMediaQuery({ maxWidth: 991 }); // sm, xs, md
      const isLargeScreen = useMediaQuery({ minWidth: 992 }); // lg and above

  console.log(planType);
  
  // ✅ Find the selected product data
  const selectedProductData = pricingData.products.find(
    (product) => product.title === selectedProduct
  );

  // ✅ Get plans based on selected type
const plans = planType === 1 
  ? selectedProductData?.monthlyPlans 
  : planType === 2 
    ? selectedProductData?.quarterlyPlans 
    :planType === 3 ? 
    selectedProductData?.yearlyPlans: null;

  return (
    <div id="pricing">
      <NavBar />
      <Container
        fluid
        style={{
          backgroundColor: theme === "dark" ? "#1e1e1e" : "",
          minHeight: "100vh",
          marginTop: "40px",
        }}
      >
        <Container className="py-5">
         <div className="text-center">
  <h2 className="fw-bold">Choose your right plan!</h2>
  <p>Select from the best plans to match your needs.</p>

  {/* Toggle Buttons & Dropdown Container */}
  <div className="d-flex flex-column flex-md-row align-items-center justify-content-around gap-3 mt-4 mb-5 position-relative">
    
    {/* Toggle Button Group */}
    <ToggleButtonGroup
      type="radio"
      name="options"
      value={planType}
      onChange={(value) => setPlanType(value)}
      className="toggle-group"
    >
      <ToggleButton
        id="tbg-radio-1"
        className="rounded-pill toggle-btn"
        value={1}
        style={{
          backgroundColor: planType === 1 ? "#835fe8" : "transparent",
          color: planType === 1 ? "white" : "#6c757d",
          border: "none",
        }}
      >
        Monthly
      </ToggleButton>
      <ToggleButton
        id="tbg-radio-2"
        className="rounded-pill toggle-btn"
        value={2}
        style={{
          backgroundColor: planType === 2 ? "#835fe8" : "transparent",
          color: planType === 2 ? "white" : "#6c757d",
          border: "none",
        }}
      >
        Quarterly (Save 10%)
      </ToggleButton>
        <ToggleButton
        id="tbg-radio-3"
        className="rounded-pill toggle-btn"
        value={3}
        style={{
          backgroundColor: planType === 3 ? "#835fe8" : "transparent",
          color: planType === 3 ? "white" : "#6c757d",
          border: "none",
        }}
      >
        Yearerly (Save 20%)
      </ToggleButton>
    </ToggleButtonGroup>

    {/* Dropdown for Product Selection at Right Corner */}

    <Dropdown
          //  className={`position-${isLargeScreen ? "absolute" : "relative"} `}

       style={{
    // position: "absolute",
// zIndex:'1',
// right: isLargeScreen ? "10px" : "", 

// Right align for lg, xl
// left:isLargeScreen? "100px":""
      //   left: isLargeScreen ? "auto" : "50%", // Center align for small screens    zIndex:"1"
  }}
      // className={`position-${isLargeScreen ? "absolute" : "relative"} `}
      // style={{
      //   right: isLargeScreen ? "10px" : "", // Right align for lg, xl
      //   left: isLargeScreen ? "auto" : "50%", // Center align for small screens
      //   transform: isLargeScreen ? "none" : "translateX(-200%)",
      //   top: "5px",
      //   zIndex:'1',
        
      // }}
    >

    {/* </Dropdown>
   <Dropdown
      className={`position-${isSmallScreen ? "relative" : "absolute"} ${
        isSmallScreen ? "drop-up" : ""
      }`}
      style={{
        right: isSmallScreen ? "auto" : "10px", // Auto for small, right for lg/xl
        left: isSmallScreen ? "20px" : "auto", // Left shift for small screens
        top: isSmallScreen ? "" : "5px", // Lower dropdown on small screens
      }}
    > */}
      <Dropdown.Toggle
        style={{
          backgroundColor: "#835fe8",
          border: "none",
          color: "white",
          padding: "10px 20px",
        }}
      >
        {selectedProduct}
      </Dropdown.Toggle>
      <Dropdown.Menu
        style={{
          backgroundColor: "#E2E8F0 ",
          width: "250px",
          borderRadius: "5px",
          right: "0px",  // Ensure the dropdown aligns to the right
          position: "absolute",
        }}
      >
        {pricingData.products.map((product, index) => (
          <Dropdown.Item
            key={index}
            onClick={() => setSelectedProduct(product.title)}
            style={{
              color: "black",
              padding: "10px",
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "")}
            onMouseLeave={(e) => (e.target.style.backgroundColor = "")}
          >
            {product.title}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  </div>
</div>


          {/* Pricing Cards Section */}
          <Row className="g-4">
            {plans?.map((plan, index) => (
              <Col key={index} md={4}>
                <Card className="pricing-card shadow-sm border-2 h-100">
                  <Card.Body className="d-flex justify-content-start flex-column">
                    <h5 className="text-dark text-uppercase">{plan.title}</h5>
                    <h2 className="mt-3 fw-bold">
                      {plan.price !== "Let's Talk!" ? `$${plan.price}` : plan.price} 
                      {plan.price !== "Let's Talk!" && <span className="fs-5"> /month</span>}
                    </h2>
                    <ul className="list-unstyled mt-3 mb-4">
                      {plan.features.map((feature, i) => (
                        <li key={i} className="mb-2">
                          <i className="bi bi-check me-2 fs-5"></i>
                          {feature}
                        </li>
                      ))}
                    </ul>
                    <div className="d-flex justify-content-center mt-auto border border-1 rounded buttonDiv">
                      <Button variant="none" className="w-50"
                       onClick={() => {
                            if (plan.buttonText === "Get started") {
                              // navigate("/book-demo");
                            } else {
                                navigate("/"); // Navigate to home page
                                  setTimeout(() => {
                                    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
                                  }, 500);                             }
                          }}>
                       
                        {plan.buttonText}
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </Container>
      <Footer />
    </div>
  );
};

export default PricingPage;
